import { type ClipSpriteSheet } from '@air/api/types';

/**
 * Gets the number of rows in the spritesheet.
 * @param spritesheet
 * @returns the number of rows, or 0 if spritesheet is undefined
 */
export const getClipSpritesheetRows = (spritesheet: ClipSpriteSheet | undefined) => {
  if (!spritesheet) {
    return 0;
  }

  return spritesheet.rows;
};
